module.exports = __webpack_public_path__ + "static/media/BAPS.3a54e004.png";